module.exports = __webpack_public_path__ + "static/assets/52d4a61d9fd788fe438f3037b9c49d3a.gif";